import React from 'react';
import {FormattedMessage} from 'react-intl';

import styles from './ThreadFileUploadList.module.css';

function createClearHandler(handler) {
    return (e) => {
        e.preventDefault();

        handler();
    };
}

function createRemoveHandler(handler, file) {
    return (e) => {
        e.preventDefault();

        handler(file);
    }
}

const ThreadFileUploadList = ({files, onClear, onRemove}) => (
    <ul className={styles.list}>
        {files.map(file => (
            <li key={file.name} className={styles.item}>
                {file.name}&nbsp;
                <button onClick={createRemoveHandler(onRemove, file)} className={styles.removeButton}>
                    X
                </button>
            </li>
        ))}
        <li className={styles.clearItem}>
            <button onClick={createClearHandler(onClear)} className={styles.clearButton}>
                <FormattedMessage id="thread.clear_upload"/>
            </button>
        </li>
    </ul>
);

export default ThreadFileUploadList;
